module.exports = __webpack_public_path__ + "portal/assets/img/AppMicrosoftAuthenticator.3130186a.png";